// extracted by mini-css-extract-plugin
module.exports = {"text":"inputLabel_text__1KVDt","title":"inputLabel_title__3n1jZ","description":"inputLabel_description__1AZpz"};